import styled from 'styled-components';
import { TextIcon, TTextIconProps } from '@landlord-tech/ui-kit-opp';

export const STextIcon = styled(TextIcon)<TTextIconProps>`
  &&& {
  }
`;
